<div class="header">
  <div>
      <div class="subtitle">{{humanReadableDocumentType}}
        @if (this.workInstance().generated_document) {
          <span
            class="link"
            go-to-details
            [element]="this.workInstance().generated_document"
            [mode]="'modal'"
          >
            #{{this.workInstance().generated_document.correlative_id}}
          </span>
        }
      </div>
  </div>
</div>

@switch (this.workInstance().work.custom_response_document_type) {
  @case ('InventoryAction::BuyOrder') {
    @if(!workInstance().completed_at) {
      <app-buy-order-create-form
        [sourceDocument]="workInstance().document"
        [sourceDocumentType]="workInstance().document_type"
        (updated)="onUpdate()"
        [workInstanceId]="workInstance().id"
        [enableDocumentSelection]="false"
        [isPluginMode]="true"
      ></app-buy-order-create-form>
    }
  }

  @case ('InventoryAction::Pricing') {
    @if(!workInstance().completed_at) {
      <app-pricing-create-form
        [sourceDocument]="workInstance().document"
        [sourceDocumentType]="workInstance().document_type"
        (updated)="onUpdate()"
        [workInstanceId]="workInstance().id"
        [enableDocumentSelection]="false"
        [isPluginMode]="true"
      ></app-pricing-create-form>
    }
  }

  @case ('InventoryAction::Stock') {
    <app-stock-create-form
      [isPluginMode]="true"
      [sourceDocument]="workInstance().generated_document || workInstance().document"
      (updated)="onUpdate()"
      [workInstanceId]="workInstance().id"
      [isReadOnly]="!!workInstance().generated_document || !!workInstance().completed_at"
    ></app-stock-create-form>
  }

  @case ('Invoice::Sale') {
    @if(!workInstance().completed_at) {
      <app-invoice-create-form
        [sourceDocument]="workInstance().document"
        [sourceDocumentType]="workInstance().document_type"
        (updated)="onUpdate()"
        [workInstanceId]="workInstance().id"
        [isPluginMode]="true"
      ></app-invoice-create-form>
    }
  }
}
